import React from 'react';
import { connect } from 'react-redux';
import { getBookList } from '../../../../api/redux-jigsaw/jigsaw-action';

class InitPageData extends React.Component {
  componentDidMount() {
    this.props.init();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  init: () => {
    // We need this for cover widths/urls only
    dispatch(getBookList({ perPage: 0 }));
  },
});

export default connect(null, mapDispatchToProps)(InitPageData);
